import { Typography, styled } from "@mui/material";
import React from "react";

export const TopNavigationText = styled(Typography)(
    ({ theme }) => `
        font-size: ${theme.typography.button.fontSize} !important;
        font-weight: 300;
    `
)

export const PositionResultText = styled(Typography)(
    ({ theme }) => `
        font-size: ${theme.typography.h2.fontSize} !important;
        font-weight: bold;
        text-align: center;
    `
)

export const TabMainTitle = styled(Typography)(
    ({ theme }) => `
        font-size: ${theme.typography.h3.fontSize} !important;
        font-weight: bold;
        text-align: center;
    `
)

export const DamaNoteTitle = styled(Typography)(
    ({ theme }) => `
        font-size: ${theme.typography.h4.fontSize} !important;
        font-weight: bold;
    `
)

export const BacklogTableTitle = styled(Typography)(
    ({ theme }) => `
        font-size: ${theme.typography.h3.fontSize} !important;
        font-weight: normal;
    `
)